import { fetchJSON, stringifyParams } from 'utils/req'

export const packetFields = [
  'id',
  'forms_count',
  'created_at',
  'qc_deadline',
  'name',
  { canvasser: ['first_name', 'last_name'] },
  { cover_sheet: 'file_url' },
  {
    forms: [
      'id',
      'county',
      'delivery_id',
      'scan_number',
      'lookup_code',
      'file_url',
      'file_locator',
      'display_name',
      'pledge_card_url',
      'notes',
      'status',
      'shift_start',
      'notes',
      'visual_review_approved',
      { canvasser: ['first_name', 'last_name'] },
      {
        visual_reviews: [
          'id',
          {
            response: [
              'id',
              'description',
              'response',
              'implies_not_form',
              'implies_skips_phone_verification',
            ],
          },
          { user: ['full_name'] },
        ],
      },
      {
        phone_verification_responses: [
          'response',
          'question_key',
          'round_number',
        ],
      },
      { flags: ['status'] },
      { shift: ['id'] },
    ],
  },
  {
    unresolved_flag_triggers: [
      'id',
      'name',
      'resource_type',
      'default_action_plan',
      'needs_reupload',
      'implies_canvasser_issue',
    ],
  },
  { assignee: ['email'] },
  { location: ['state', 'name', 'timezone', 'category'] },
  { creator: 'time_zone' },
  {
    turf: [
      'id',
      'name',
      'language',
      'voter_registration_config',
      { phone_verification_scripts: ['language', 'structure'] },
      {
        visual_review_responses: [
          'id',
          'description',
          'response',
          'active',
          'grouping_metadata',
          'reviewable_type',
        ],
      },
    ],
  },
]

type FetchUnresolvedFlagTriggers = {
  shift: {
    forms: Array<{
      unresolved_flag_triggers: Array<{
        stops_qc: boolean
        needs_reupload: boolean
      }>
    }>
  }
}

export const fetchUnresolvedFlagTriggers = (id: number) => {
  const params = stringifyParams({
    fields: [
      { forms: [{ unresolved_flag_triggers: ['stops_qc', 'needs_reupload'] }] },
    ],
  })
  return fetchJSON<FetchUnresolvedFlagTriggers>(
    `/api/v1/shifts/${id}?${params}`,
    'GET',
    null,
    { useJwt: true }
  )
}

export const deletePacket = (id: number) =>
  fetchJSON(`/api/v1/shifts/${id}/forms`, 'DELETE', undefined, {
    useJwt: true,
  })
